import { List, ListItem, ListItemButton, ListItemText, Chip, Box, Paper, Typography } from "@mui/material";
import { Fragment } from "react";
import './ModListBox.css';

function ModListBox({ title, titleColor, mapMod, searchWord, selected, ignoreSelected, onItemClick, show17Mod, lvOrder }) {
  const colorLv = ['#ef4444', '#f87171', '#fca5a5', '#fee2e2', '#fef2f2', '#a385d9'];

  const getOptColor = (opt) => {
    if (!opt) return '#7b2cbf';
    if (opt.startsWith('화폐')) return '#f59e0b';  // 노란색 계열 (amber-500)
    if (opt.startsWith('갑충')) return '#10b981';  // 초록색 계열 (emerald-500)
    if (opt.startsWith('지도')) return '#3b82f6';  // 파란색 계열 chose (blue-500)
    return '#7b2cbf';  // 기본 보라색
  };

  const filterMod = mapMod.filter((data) => {
    if (show17Mod && data.lv !== 17)
      return false;
    if(!searchWord)
      return true;
    return (data.mod).includes(searchWord);
  })

  if (lvOrder) {
    filterMod.sort((a, b) => lvOrder.indexOf(a.lv) - lvOrder.indexOf(b.lv));
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        maxHeight: { xs: 'none', md: 560 },
        overflowY: { xs: 'visible', md: 'auto' },
      }}
    >
      {title && (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1, px: 1.5, py: 1, bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: titleColor }}>{title}</Typography>
        </Box>
      )}
      <List dense disablePadding>
      {
        filterMod.map((data) => {
          return (
            <ListItem disablePadding={true} key={data.id}>
              <ListItemButton sx={{ py: 0.75, '&:hover': { bgcolor: 'action.hover' } }} onClick={() => onItemClick(data.id, data)}>
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ListItemText className={(selected.includes(data.id) ? 'wantSelectMod' : '')
                    + (ignoreSelected.includes(data.id) ? ' ignoreSelectMod' : '')}
                    sx={{ color: `${data.lv != 17 ? colorLv[data.lv-1] : colorLv[5]}`, m: 0, padding: '4px'}}>
                      {data.mod.split('\n').map((line, index) => (
                        <Fragment key={index}>
                          {line}
                          <br />
                        </Fragment>
                      ))}
                  </ListItemText>
                  {data.opt && (
                    <Chip
                      label={data.opt}
                      size="small"
                      sx={{
                        bgcolor: getOptColor(data.opt),
                        color: 'white',
                        fontSize: '11px',
                        height: '20px',
                        flexShrink: 0
                      }}
                    />
                  )}
                </Box>
              </ListItemButton>
            </ListItem>
          );
        })
      }
      </List>
    </Paper>
  );
}

export default ModListBox;
